import React from "react";

type NotificationSettingChannelIconProps = {
  color?: string;
};

const NotificationSettingChannelIcon = (
  props: NotificationSettingChannelIconProps
) => {
  const { color } = props;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99992 2.16668C9.99992 1.70834 9.60992 1.33334 9.13325 1.33334H2.19992C1.72325 1.33334 1.33325 1.70834 1.33325 2.16668M9.99992 2.16668V4.33334M9.99992 2.16668L5.66659 5.08334L1.33325 2.16668M4.33325 8.00001H2.19992C1.72325 8.00001 1.33325 7.62501 1.33325 7.16668V2.16668M8.99992 8.8889H12.3333M8.99992 10.6667H11.4444M14.6666 12C14.6666 12.2358 14.5729 12.4619 14.4062 12.6285C14.2395 12.7952 14.0134 12.8889 13.7777 12.8889H8.44436L6.66659 14.6667V7.55557C6.66659 7.31982 6.76024 7.09373 6.92693 6.92703C7.09363 6.76033 7.31973 6.66668 7.55547 6.66668H13.7777C14.0134 6.66668 14.2395 6.76033 14.4062 6.92703C14.5729 7.09373 14.6666 7.31982 14.6666 7.55557V12Z"
        stroke={color || "#739CFF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationSettingChannelIcon;
